import * as Sentry from "@sentry/remix";

/**
 * Due to separate trace and performance monitoring. Sentry (bugsink) only catch and send error.
 */
export const init = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    profilesSampleRate: 0,
    tracesSampleRate: 0,
    sendDefaultPii: true,
    integrations: [],
    beforeSend: (event) => {
      if (event.level !== "error") return null;

      return event;
    },
  });
};
